import React from 'react';
import PropTypes from 'prop-types';

import Navbar from './Navbar';
import '../layouts/generated.css';
import Footer from './Footer';

const TemplateWrapper = ({ children }) => {
  return (
    <div>
      <div className="relative">
        <Navbar />
      </div>
      <div style={{ minHeight: 'calc(100vh - 225px)' }}>{children}</div>
      <Footer />
    </div>
  );
};

TemplateWrapper.propTypes = {
  children: PropTypes.any.isRequired,
};

export default TemplateWrapper;
